// @ts-nocheck
import { imageStyles, ImageStyles } from "@insite/content-library/Widgets/Basic/Image";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

Object.assign(imageStyles, {
    wrapper: {
        css: css`
            ${spacingStyles()}
        `,
    },
    img: {
        css: css`
            background-color: transparent;
            display: block;
            width: 100%;
            height: auto;
        `,
    },
} as ImageStyles);
